  // nav scroll state
  const nav = document.getElementById('nav');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  });

  // mobile menu toggle
  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobileMenu');
  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('open');
    mobileMenu.classList.toggle('open');
  });
  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      hamburger.classList.remove('open');
      mobileMenu.classList.remove('open');
    });
  });

  // shade swatch interaction -> retheme the entire site
  const shadeItems = document.querySelectorAll('.shade-item');
  const tubeBody = document.querySelector('#tubeBody stop:nth-child(3)');
  const root = document.documentElement;
  shadeItems.forEach(item => {
    item.addEventListener('click', () => {
      shadeItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      const color = item.getAttribute('data-color');
      if (tubeBody) tubeBody.setAttribute('stop-color', color);

      root.style.setProperty('--rose-deep', item.getAttribute('data-deep'));
      root.style.setProperty('--rose-mid', item.getAttribute('data-mid'));
      root.style.setProperty('--blush', item.getAttribute('data-blush'));
      root.style.setProperty('--shimmer', item.getAttribute('data-shimmer'));
    });
  });

  // scroll reveal
  const revealEls = document.querySelectorAll('.reveal');
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  revealEls.forEach(el => io.observe(el));
